import { render, staticRenderFns } from "./Chengjiguanli.vue?vue&type=template&id=54980ed0&"
import script from "./Chengjiguanli.vue?vue&type=script&lang=js&"
export * from "./Chengjiguanli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports